import { render, staticRenderFns } from "./ExportDealerInspections.vue?vue&type=template&id=1f12811a&scoped=true&"
import script from "./ExportDealerInspections.vue?vue&type=script&lang=ts&"
export * from "./ExportDealerInspections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f12811a",
  null
  
)

export default component.exports